import { useId } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box } from "@mui/material";
import { useColorScheme } from "@mui/material/styles";

export const GripLinesIcon = () => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fas"
      data-icon="grip-lines"
      className="svg-inline--fa fa-grip-lines fa-w-16"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
      ></path>
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fas"
      data-icon="home"
      className="svg-inline--fa fa-home fa-w-18"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
    >
      <path
        fill="currentColor"
        d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
      />
    </svg>
  );
};

export const LogoutIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="unlock-alt"
    className="svg-inline--fa fa-unlock-alt fa-w-14"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
    />
  </svg>
);

export const UserCircleIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="user-circle"
    className="svg-inline--fa fa-user-circle fa-w-16"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 496 512"
  >
    <path
      fill="currentColor"
      d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    />
  </svg>
);

export const GlassLowLevelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.27 17.44">
    <rect
      fill="var(--mui-palette-error-main)"
      fillOpacity="0.3"
      strokeLinecap="round"
      strokeMiterlimit="10"
      stroke="var(--mui-palette-error-main)"
      strokeOpacity="0.3"
      x=".83"
      y="2.24"
      width="9.23"
      height=".93"
    />
    <line
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      stroke="var(--mui-palette-error-main)"
      x1="1.86"
      y1="16.94"
      x2="9.46"
      y2="16.94"
    />
    <line
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      stroke="var(--mui-palette-error-main)"
      x1="5.66"
      y1="8.54"
      x2="5.66"
      y2="16.94"
    />
    <path
      fill="var(--mui-palette-error-main)"
      fillOpacity="0.3"
      strokeLinecap="round"
      strokeMiterlimit="10"
      stroke="var(--mui-palette-error-main)"
      d="m.5,2.93c.11,2.83,2.19,4.99,4.7,5.21,2.73.23,5.35-2.04,5.57-5.21"
    />
    <line
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      stroke="var(--mui-palette-error-main)"
      x1="10.77"
      y1="2.82"
      x2="10.77"
      y2=".5"
    />
    <line
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      stroke="var(--mui-palette-error-main)"
      x1=".72"
      y1="2.24"
      x2="10.72"
      y2="2.24"
    />
    <line
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      stroke="var(--mui-palette-error-main)"
      x1=".5"
      y1="2.82"
      x2=".5"
      y2=".5"
    />
  </svg>
);

export const GlassMediumLevelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.36 16.52">
    <rect
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeOpacity="0.3"
      strokeLinecap="round"
      strokeMiterlimit="10"
      x=".77"
      y="2.37"
      width="8.95"
      height=".51"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      x1="1.39"
      y1="16.02"
      x2="8.98"
      y2="16.02"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      x1="5.19"
      y1="7.63"
      x2="5.19"
      y2="16.02"
    />
    <path
      fill="var(--mui-palette-text-secondary)"
      fillOpacity="0.3"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="m.5,2.62c.1,2.46,2.01,4.42,4.31,4.58,2.53.18,4.88-1.85,5.05-4.56"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      x1="9.86"
      y1="2.6"
      x2="9.86"
      y2=".55"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      x1=".5"
      y1="2.58"
      x2=".5"
      y2=".55"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      x1="9.84"
      y1=".51"
      x2=".5"
      y2=".5"
    />
  </svg>
);

export const GlassHighLevelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.77 16.52">
    <rect
      strokeLinecap="round"
      strokeMiterlimit="10"
      fill="none"
      stroke="var(--mui-palette-primary-main)"
      strokeOpacity="0.3"
      x="6.94"
      y="1.48"
      width="8.95"
      height=".93"
    />
    <line
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      fill="none"
      x1="7.56"
      y1="16.02"
      x2="15.15"
      y2="16.02"
    />
    <line
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      fill="none"
      x1="11.36"
      y1="7.63"
      x2="11.36"
      y2="16.02"
    />
    <path
      fill="var(--mui-palette-primary-main)"
      fillOpacity="0.3"
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="m6.67,2.62c.1,2.46,2.01,4.42,4.31,4.58,2.53.18,4.88-1.85,5.05-4.56"
    />
    <line
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      fill="none"
      x1="16.03"
      y1="2.6"
      x2="16.03"
      y2=".55"
    />
    <line
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      fill="none"
      x1="6.67"
      y1="2.58"
      x2="6.67"
      y2=".55"
    />
    <line
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      fill="none"
      x1="16.01"
      y1=".51"
      x2="6.67"
      y2=".5"
    />
    <path
      fill="var(--mui-palette-primary-main)"
      fillOpacity="0.3"
      stroke="var(--mui-palette-primary-main)"
      strokeWidth="0.5px"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="m4.46.51c-.42.05-1.93,1.21-2.16,1.67-.25.5,0,1.16.44,1.4.4.21.84.04.98-.07.57-.4.86-2.83.77-2.95"
    />
    <path
      fill="var(--mui-palette-primary-main)"
      fillOpacity="0.3"
      stroke="var(--mui-palette-primary-main)"
      strokeWidth="0.5px"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="m18.26.51c.42.05,1.93,1.21,2.16,1.67.25.5,0,1.16-.44,1.4-.4.21-.84.04-.98-.07-.57-.4-.86-2.83-.77-2.95"
    />
  </svg>
);

export const ModeleIcon = () => (
  <svg
    id="Calque_1"
    data-name="Calque 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17.86 17.88"
  >
    <line
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      x1="17.36"
      y1=".5"
      x2="17.36"
      y2="17.36"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      x1=".5"
      y1="17.38"
      x2="17.36"
      y2="17.38"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      x1="3.66"
      y1="13.15"
      x2="12.57"
      y2="3.96"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M2.24,12.26c.2-1,.95-4.24,3.78-6.81,2.21-2.01,4.54-2.57,5.56-2.76"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M4.6,14.46c.99-.22,4.2-1.04,6.7-3.93,1.96-2.26,2.48-4.61,2.64-5.64"
    />
  </svg>
);

export const AlertePUArrowDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
  >
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="1.3"
      y1="22.1"
      x2="5.2"
      y2="9.2"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="5.2"
      y1="9.2"
      x2="17"
      y2="6.9"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      x1="17.5"
      y1="9.6"
      x2="16.7"
      y2="4.2"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      x1="17.6"
      y1="9.6"
      x2="23.1"
      y2="5.9"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      x1="23.1"
      y1="5.8"
      x2="16.7"
      y2="4.2"
    />
  </svg>
);

export const AlertePUArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.08 12.54">
    <line
      strokeLinejoin="round"
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      x1=".5"
      y1="12.04"
      x2="14.29"
      y2="4.51"
    />
    <g>
      <line
        fill="none"
        stroke="var(--mui-palette-text-secondary)"
        strokeLinecap="round"
        x1="13.27"
        y1="1.26"
        x2="16.52"
        y2="7.1"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-text-secondary)"
        strokeLinecap="round"
        x1="13.32"
        y1="1.23"
        x2="21.57"
        y2=".5"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-text-secondary)"
        strokeLinecap="round"
        x1="21.58"
        y1=".51"
        x2="16.56"
        y2="7.05"
      />
    </g>
  </svg>
);

export const AlertePUArrowUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
  >
    <g>
      <line
        fill="none"
        stroke="var(--mui-palette-primary-main)"
        strokeLinecap="round"
        strokeLinejoin="round"
        x1="2.25"
        y1="21.51"
        x2="15.63"
        y2="19.87"
      />
    </g>
    <line
      fill="none"
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="15.69"
      y1="19.79"
      x2="19.89"
      y2="8.55"
    />
    <g>
      <defs>
        <rect x="1.08" y="1.86" width="21.94" height="20.28" />
      </defs>
      <line
        fill="none"
        stroke="var(--mui-palette-primary-main)"
        strokeLinecap="round"
        x1="17.34"
        y1="7.62"
        x2="22.47"
        y2="9.31"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-primary-main)"
        strokeLinecap="round"
        x1="17.35"
        y1="7.57"
        x2="21.9"
        y2="2.74"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-primary-main)"
        strokeLinecap="round"
        x1="21.92"
        y1="2.74"
        x2="22.47"
        y2="9.26"
      />
    </g>
  </svg>
);

export const AlertePUIndivArrowDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.8 21.17">
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1=".5"
      y1="20.67"
      x2="4.4"
      y2="7.77"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="4.4"
      y1="7.77"
      x2="16.2"
      y2="5.47"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="16.7"
      y1="8.17"
      x2="15.9"
      y2="2.77"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="16.8"
      y1="8.17"
      x2="22.3"
      y2="4.47"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="22.3"
      y1="4.37"
      x2="15.9"
      y2="2.77"
    />
    <text
      fill="var(--mui-palette-error-main)"
      fontFamily="MSReferenceSansSerif, 'MS Reference Sans Serif'"
      fontSize="8px"
      transform="translate(.2 6.91)"
    >
      <tspan x="0" y="0">
        I
      </tspan>
    </text>
  </svg>
);

export const AlertePUIndivArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.24 17.43">
    <line
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1=".66"
      y1="16.93"
      x2="15.08"
      y2="9.2"
    />
    <g>
      <line
        fill="none"
        stroke="var(--mui-palette-text-secondary)"
        strokeLinecap="round"
        x1="13.43"
        y1="6.15"
        x2="16.68"
        y2="11.99"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-text-secondary)"
        strokeLinecap="round"
        x1="13.48"
        y1="6.11"
        x2="21.73"
        y2="5.39"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-text-secondary)"
        strokeLinecap="round"
        x1="21.74"
        y1="5.4"
        x2="16.72"
        y2="11.94"
      />
    </g>
    <text
      fill="var(--mui-palette-text-secondary)"
      fontFamily="MSReferenceSansSerif, 'MS Reference Sans Serif'"
      fontSize="8px"
      transform="translate(0 6.91)"
    >
      <tspan x="0" y="0">
        I
      </tspan>
    </text>
  </svg>
);

export const AlertePUIndivArrowUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.99 21.9">
    <defs>
      <clipPath id="clippath">
        <rect fill="none" y="1.62" width="21.94" height="20.28" />
      </clipPath>
      <clipPath id="clippath-1">
        <rect fill="none" x=".05" y="1.62" width="21.94" height="20.28" />
      </clipPath>
      <clipPath id="clippath-2">
        <rect fill="none" x=".05" y="1.62" width="21.94" height="20.28" />
      </clipPath>
      <clipPath id="clippath-3">
        <rect fill="none" x=".05" y="1.62" width="21.94" height="20.28" />
      </clipPath>
    </defs>
    <g clipPath="url(#clippath)">
      <line
        fill="none"
        stroke="var(--mui-palette-primary-main)"
        strokeLinecap="round"
        strokeLinejoin="round"
        x1="1.22"
        y1="21.27"
        x2="14.6"
        y2="19.63"
      />
    </g>
    <line
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      fill="none"
      strokeLinejoin="round"
      x1="14.66"
      y1="19.55"
      x2="18.86"
      y2="8.31"
    />
    <g>
      <g clipPath="url(#clippath-1)">
        <line
          fill="none"
          stroke="var(--mui-palette-primary-main)"
          strokeLinecap="round"
          x1="16.31"
          y1="7.38"
          x2="21.44"
          y2="9.07"
        />
      </g>
      <g clipPath="url(#clippath-2)">
        <line
          fill="none"
          stroke="var(--mui-palette-primary-main)"
          strokeLinecap="round"
          x1="16.32"
          y1="7.33"
          x2="20.87"
          y2="2.5"
        />
      </g>
      <g clipPath="url(#clippath-3)">
        <line
          fill="none"
          stroke="var(--mui-palette-primary-main)"
          strokeLinecap="round"
          x1="20.89"
          y1="2.5"
          x2="21.44"
          y2="9.02"
        />
      </g>
    </g>
    <text
      fill="var(--mui-palette-primary-main)"
      fontFamily="MSReferenceSansSerif, 'MS Reference Sans Serif"
      fontSize="8px"
      transform="translate(.22 6.91)"
    >
      <tspan x="0" y="0">
        I
      </tspan>
    </text>
  </svg>
);

export const RecoMinSet = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.06 19.4">
    <text
      fill="var(--mui-palette-primary-main)"
      fontFamily="MSReferenceSansSerif, 'MS Reference Sans Serif'"
      fontSize="10px"
      transform="translate(2.4 12.97)"
    >
      <tspan x="0" y="0">
        MS
      </tspan>
    </text>
    <ellipse
      fill="none"
      opacity="0.6"
      stroke="var(--mui-palette-primary-main)"
      strokeMiterlimit="10"
      cx="10.03"
      cy="9.7"
      rx="9.53"
      ry="9.2"
    />
  </svg>
);

export const ChevronRightDisable = () => (
  <KeyboardArrowRightIcon sx={{ color: "text.disabled" }} />
);

export const ChevronLeftDisable = () => (
  <KeyboardArrowLeftIcon sx={{ color: "text.disabled" }} />
);

export const RecoMinSetDisable = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.06 19.4">
    <text
      fill="var(--mui-palette-text-disabled)"
      fontFamily="MSReferenceSansSerif, 'MS Reference Sans Serif'"
      fontSize="10px"
      transform="translate(2.4 12.97)"
    >
      <tspan x="0" y="0">
        MS
      </tspan>
    </text>
    <ellipse
      fill="none"
      opacity="0.6"
      stroke="var(--mui-palette-text-disabled)"
      strokeMiterlimit="10"
      cx="10.03"
      cy="9.7"
      rx="9.53"
      ry="9.2"
    />
  </svg>
);

export const RecoMinRemove = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.06 19.4">
    <line
      fill="none"
      opacity="0.6"
      stroke="var(--mui-palette-error-main)"
      strokeLinejoin="bevel"
      x1="3.96"
      y1="3.25"
      x2="16.02"
      y2="16.23"
    />
    <text
      fill="var(--mui-palette-error-main)"
      fontFamily="MSReferenceSansSerif, 'MS Reference Sans Serif'"
      fontSize="10px"
      transform="translate(2.4 12.97)"
    >
      <tspan x="0" y="0">
        MS
      </tspan>
    </text>
    <ellipse
      fill="none"
      opacity="0.6"
      stroke="var(--mui-palette-error-main)"
      strokeMiterlimit="10"
      cx="10.03"
      cy="9.7"
      rx="9.53"
      ry="9.2"
    />
  </svg>
);

export const RecoMinRemoveDisable = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.06 19.4">
    <line
      fill="none"
      opacity="0.6"
      stroke="var(--mui-palette-text-disabled)"
      strokeLinejoin="bevel"
      x1="3.96"
      y1="3.25"
      x2="16.02"
      y2="16.23"
    />
    <text
      fill="var(--mui-palette-text-disabled)"
      fontFamily="MSReferenceSansSerif, 'MS Reference Sans Serif'"
      fontSize="10px"
      transform="translate(2.4 12.97)"
    >
      <tspan x="0" y="0">
        MS
      </tspan>
    </text>
    <ellipse
      fill="none"
      opacity="0.6"
      stroke="var(--mui-palette-text-disabled)"
      strokeMiterlimit="10"
      cx="10.03"
      cy="9.7"
      rx="9.53"
      ry="9.2"
    />
  </svg>
);

export const RecoPriceDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.9 20.4">
    <text
      fill="var(--mui-palette-error-main)"
      fontFamily="MSReferenceSansSerif, 'MS Reference Sans Serif'"
      fontSize="19px"
      transform="translate(0 16.41)"
    >
      <tspan x="0" y="0">
        €
      </tspan>
    </text>
    <line
      strokeLinejoin="round"
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      x1="16.1"
      y1="1.32"
      x2="16.12"
      y2="12.83"
    />
    <g>
      <line
        fill="none"
        stroke="var(--mui-palette-error-main)"
        strokeLinecap="round"
        x1="18.4"
        y1="12.9"
        x2="13.84"
        y2="12.88"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-error-main)"
        strokeLinecap="round"
        x1="18.4"
        y1="12.94"
        x2="16.08"
        y2="18.25"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-error-main)"
        strokeLinecap="round"
        x1="16.07"
        y1="18.26"
        x2="13.86"
        y2="12.92"
      />
    </g>
  </svg>
);

export const RecoPriceDownDisable = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.9 20.4">
    <text
      fill="var(--mui-palette-text-disabled)"
      fontFamily="MSReferenceSansSerif, 'MS Reference Sans Serif'"
      fontSize="19px"
      transform="translate(0 16.41)"
    >
      <tspan x="0" y="0">
        €
      </tspan>
    </text>
    <line
      strokeLinejoin="round"
      fill="none"
      stroke="var(--mui-palette-text-disabled)"
      strokeLinecap="round"
      x1="16.1"
      y1="1.32"
      x2="16.12"
      y2="12.83"
    />
    <g>
      <line
        fill="none"
        stroke="var(--mui-palette-text-disabled)"
        strokeLinecap="round"
        x1="18.4"
        y1="12.9"
        x2="13.84"
        y2="12.88"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-text-disabled)"
        strokeLinecap="round"
        x1="18.4"
        y1="12.94"
        x2="16.08"
        y2="18.25"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-text-disabled)"
        strokeLinecap="round"
        x1="16.07"
        y1="18.26"
        x2="13.86"
        y2="12.92"
      />
    </g>
  </svg>
);

export const RecoPriceUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.9 20.4">
    <text
      fill="var(--mui-palette-primary-main)"
      fontFamily="MSReferenceSansSerif, 'MS Reference Sans Serif'"
      fontSize="19px"
      transform="translate(0 16.41)"
    >
      <tspan x="0" y="0">
        €
      </tspan>
    </text>
    <line
      strokeLinejoin="round"
      fill="none"
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      x1="16.1"
      y1="18.26"
      x2="16.12"
      y2="6.74"
    />
    <g>
      <line
        fill="none"
        stroke="var(--mui-palette-primary-main)"
        strokeLinecap="round"
        x1="18.4"
        y1="6.68"
        x2="13.84"
        y2="6.7"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-primary-main)"
        strokeLinecap="round"
        x1="18.4"
        y1="6.63"
        x2="16.08"
        y2="1.32"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-primary-main)"
        strokeLinecap="round"
        x1="16.07"
        y1="1.32"
        x2="13.86"
        y2="6.65"
      />
    </g>
  </svg>
);

export const RecoPriceUpDisable = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.9 20.4">
    <text
      fill="var(--mui-palette-text-disabled)"
      fontFamily="MSReferenceSansSerif, 'MS Reference Sans Serif'"
      fontSize="19px"
      transform="translate(0 16.41)"
    >
      <tspan x="0" y="0">
        €
      </tspan>
    </text>
    <line
      strokeLinejoin="round"
      fill="none"
      stroke="var(--mui-palette-text-disabled)"
      strokeLinecap="round"
      x1="16.1"
      y1="18.26"
      x2="16.12"
      y2="6.74"
    />
    <g>
      <line
        fill="none"
        stroke="var(--mui-palette-text-disabled)"
        strokeLinecap="round"
        x1="18.4"
        y1="6.68"
        x2="13.84"
        y2="6.7"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-text-disabled)"
        strokeLinecap="round"
        x1="18.4"
        y1="6.63"
        x2="16.08"
        y2="1.32"
      />
      <line
        fill="none"
        stroke="var(--mui-palette-text-disabled)"
        strokeLinecap="round"
        x1="16.07"
        y1="1.32"
        x2="13.86"
        y2="6.65"
      />
    </g>
  </svg>
);

export const JaugeDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.16 11.36">
    <path
      strokeMiterlimit="10"
      fill="none"
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeWidth="0.5px"
      d="m2.54,11.11C.86,9.93,0,7.72.31,5.68c.29-1.95,1.33-3.59,2.9-4.52C4.58.35,6.03.18,7.51.27c1.79.11,3.63.69,4.86,2,.89.95,1.41,2.2,1.52,3.66.15,2.05-.63,3.83-2.04,5.09"
    />
    <line
      strokeMiterlimit="10"
      fill="none"
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeWidth="0.5px"
      x1="1.28"
      y1="3.06"
      x2="2.35"
      y2="3.95"
    />
    <line
      strokeMiterlimit="10"
      fill="none"
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeWidth="0.5px"
      x1="10.13"
      y1="1.04"
      x2="9.54"
      y2="2.33"
    />
    <path
      fill="none"
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeWidth="0.5px"
      strokeLinejoin="round"
      d="m2.35,3.95c.33-.33.6-.58.96-.89s.8-.55,1.26-.75.72-.25,1.23-.34c1.15-.21,2.47-.06,3.75.36"
    />
    <line
      strokeMiterlimit="10"
      fill="none"
      stroke="var(--mui-palette-primary-main)"
      strokeLinecap="round"
      strokeWidth="0.5px"
      x1="7.08"
      y1="7.01"
      x2="2.09"
      y2="9.34"
    />
  </svg>
);

export const JaugeUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.16 11.36">
    <path
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeWidth="0.5px"
      strokeMiterlimit="10"
      d="m2.54,11.11C.86,9.93,0,7.72.31,5.68c.29-1.95,1.33-3.59,2.9-4.52C4.58.35,6.03.18,7.51.27c1.79.11,3.63.69,4.86,2,.89.95,1.41,2.2,1.52,3.66.15,2.05-.63,3.83-2.04,5.09"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeWidth="0.5px"
      strokeMiterlimit="10"
      x1="1.28"
      y1="3.06"
      x2="2.35"
      y2="3.95"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeWidth="0.5px"
      strokeMiterlimit="10"
      x1="10.13"
      y1="1.04"
      x2="9.54"
      y2="2.33"
    />
    <path
      strokeLinejoin="round"
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeWidth="0.5px"
      d="m2.35,3.95c.33-.33.6-.58.96-.89s.8-.55,1.26-.75.72-.25,1.23-.34c1.15-.21,2.47-.06,3.75.36"
    />
    <line
      fill="none"
      stroke="var(--mui-palette-error-main)"
      strokeLinecap="round"
      strokeWidth="0.5px"
      strokeMiterlimit="10"
      x1="7.08"
      y1="7.01"
      x2="12.48"
      y2="4.16"
    />
  </svg>
);

export const JaugeMedium = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Calque_1"
    data-name="Calque 1"
    viewBox="0 0 14.16 11.36"
  >
    <path
      strokeMiterlimit="10"
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeWidth=".5px"
      d="m2.54,11.11C.86,9.93,0,7.72.31,5.68c.29-1.95,1.33-3.59,2.9-4.52C4.58.35,6.03.18,7.51.27c1.79.11,3.63.69,4.86,2,.89.95,1.41,2.2,1.52,3.66.15,2.05-.63,3.83-2.04,5.09"
    />
    <line
      strokeMiterlimit="10"
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeWidth=".5px"
      x1="1.28"
      y1="3.06"
      x2="2.35"
      y2="3.95"
    />
    <line
      strokeMiterlimit="10"
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeWidth=".5px"
      x1="10.13"
      y1="1.04"
      x2="9.54"
      y2="2.33"
    />
    <path
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeWidth=".5px"
      strokeLinejoin="round"
      d="m2.35,3.95c.33-.33.6-.58.96-.89s.8-.55,1.26-.75.72-.25,1.23-.34c1.15-.21,2.47-.06,3.75.36"
    />
    <line
      strokeMiterlimit="10"
      fill="none"
      stroke="var(--mui-palette-text-secondary)"
      strokeLinecap="round"
      strokeWidth=".5px"
      x1="7.08"
      y1="7.01"
      x2="5.23"
      y2="1.52"
    />
  </svg>
);

export const RevbellIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 138 138"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M68.65 0C14.99 0 0 14.99 0 68.65C0 122.31 14.99 137.3 68.65 137.3C122.31 137.3 137.3 122.31 137.3 68.65C137.3 14.99 122.32 0 68.65 0ZM101.86 89.67C101.86 99.96 98.99 102.84 88.7 102.84H75.54H72.89C75.11 100.62 75.54 97.14 75.54 89.67C75.54 79.38 78.41 76.5 88.7 76.5C98.99 76.5 101.86 79.37 101.86 89.67ZM101.86 54.82C101.86 58.51 98.72 61.43 95.05 61.13C91.69 60.86 87.94 60.73 85.02 60.73C84.97 60.73 84.93 60.73 84.88 60.73C80.32 60.73 76.5 61.02 73.34 61.71C66.29 63.24 61.35 69.64 61.35 76.86L61.39 77.44C61.39 85.44 61.09 92.27 59.87 97.07C59 100.48 55.9 102.84 52.39 102.84H35.45V47.7C35.45 41.47 40.5 36.42 46.73 36.42H101.87V54.82H101.86Z"
        fill="#ffffff"
      />
    </g>
  </svg>
);

export const Nancie = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
    <linearGradient id="myGradient" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stopColor="#C580F1" />
      <stop offset="100%" stopColor="#8473EA" />
    </linearGradient>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 79.5065C0 94.8703 4.30007 99.1555 19.6639 99.1555C35.0426 99.1555 39.3277 94.8703 39.3277 79.5065C39.3277 64.1427 35.0277 59.8576 19.6639 59.8576C8.51056 59.8576 3.31464 59.2156 0 55.9009V79.5065Z"
      fill="url(#myGradient)"
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62.2764 88.9876C61.8285 94.4672 66.1883 99.1555 71.6977 99.1555V99.1704H99.1704V16.8419C99.1704 7.54006 91.6304 0 82.3285 0H0V25.2928C0 30.5335 3.52366 35.162 8.61507 36.461C15.7819 38.2826 25.9796 38.7305 37.9242 38.7305L38.7902 38.6708C49.5703 38.6708 59.126 46.0466 61.4104 56.5728C62.4406 61.291 62.8736 66.9945 62.8736 73.803V74.012C62.8736 78.3718 62.6795 83.9709 62.2764 88.9876Z"
      fill="url(#myGradient)"
    ></path>
  </svg>
);

// 24px white Nancie mark, for the violet Nancie surfaces (reco card header).
export const NancieMark = () => (
  <Box
    sx={{
      width: 24,
      height: 24,
      display: "flex",
      "& svg": { width: 24, height: 24 },
      "& svg path": { fill: "#fff" },
    }}
  >
    <Nancie />
  </Box>
);

export const LogoNanciePurpleWhite = ({
  size = 24,
}: {
  size?: number | string;
}) => {
  const id = useId();
  const gradientId = `nancie-gradient-${id}`;
  const clipId = `nancie-clip-${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 205 205"
      fill="none"
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M205 102.5C205 22.3813 182.619 0 102.5 0C22.3813 0 0 22.3813 0 102.5C0 182.619 22.3813 205 102.5 205C182.619 205 205 182.634 205 102.5ZM71.1154 152.085C55.7516 152.085 51.4516 147.8 51.4516 132.436V112.787V108.831C54.7662 112.145 59.9621 112.787 71.1154 112.787C86.4792 112.787 90.7793 117.072 90.7793 132.436C90.7793 147.8 86.4942 152.085 71.1154 152.085ZM123.149 152.085C117.64 152.085 113.28 147.397 113.728 141.917C114.131 136.901 114.325 131.302 114.325 126.942C114.325 126.867 114.325 126.807 114.325 126.733C114.325 119.924 113.892 114.221 112.862 109.503C110.578 98.9763 101.022 91.6005 90.2418 91.6005L89.3758 91.6602C77.4312 91.6602 67.2334 91.2123 60.0666 89.3907C54.9752 88.0918 51.4516 83.4632 51.4516 78.2225V52.9297H133.78C143.082 52.9297 150.622 60.4698 150.622 69.7717V152.1H123.149V152.085Z"
          fill={`url(#${gradientId})`}
        />
      </g>
      <defs>
        <linearGradient
          id={gradientId}
          x1="205"
          y1="102.5"
          x2="0"
          y2="102.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C580F1" />
          <stop offset="1" stopColor="#8473EA" />
        </linearGradient>
        <clipPath id={clipId}>
          <rect
            width="205"
            height="205"
            fill="white"
            transform="matrix(0 1 -1 0 205 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// Nancie wordmark logo: purple gradient mark + theme-aware text.
// The text color follows the active theme; both shades are sampled from the
// original PNG wordmarks (dark teal on light, warm off-white on dark).
// The gradient "a" mark stays constant.
//
// Accessibility: pass `title` to give the logo an accessible name (e.g. the
// header logo), or `decorative` to hide it from assistive tech when it is
// purely visual (e.g. repeated next to a text label). Exactly one of the two
// applies; `decorative` wins if both are set.
export const IaNancie = ({
  height = 32,
  title,
  decorative = false,
}: {
  height?: number | string;
  title?: string;
  decorative?: boolean;
}) => {
  const { mode, systemMode } = useColorScheme();
  const resolvedMode = mode === "system" ? systemMode : mode;
  const textColor = resolvedMode === "dark" ? "#F7F2E8" : "#012625";

  // Unique ids so multiple instances don't share gradient/clip definitions.
  const rawId = useId();
  const uid = rawId.replace(/:/g, "");
  const clipId = `${uid}-clip`;
  const gradMarkId = `${uid}-grad-mark`;
  const gradDotId = `${uid}-grad-dot`;
  const titleId = `${uid}-title`;

  const a11yProps = decorative
    ? { "aria-hidden": true, focusable: false }
    : title
    ? { role: "img", "aria-labelledby": titleId }
    : {};

  return (
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="101.3 292.3 1778.7 462.8"
      sx={{ height, width: "auto", display: "block" }}
      {...a11yProps}
    >
      {!decorative && title ? <title id={titleId}>{title}</title> : null}
      <defs>
        <clipPath id={clipId}>
          <path
            fill="none"
            d="M1606.8,400.8v19.6c0,15.3,4.3,19.6,19.6,19.6h0c15.3,0,19.6-4.3,19.6-19.6s-4.3-19.6-19.6-19.6h0c-11.1,0-16.3-.6-19.6-3.9v3.9Z"
          />
        </clipPath>
        <linearGradient
          id={gradDotId}
          x1="0"
          y1="-182.3"
          x2="1"
          y2="-182.3"
          gradientTransform="translate(1606.8 -6714.5) scale(39.1 -39.1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#8473ea" />
          <stop offset="1" stopColor="#c580f1" />
        </linearGradient>
        <linearGradient
          id={gradMarkId}
          x1="113.4"
          y1="523.7"
          x2="552.1"
          y2="523.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#8473ea" />
          <stop offset="1" stopColor="#c580f1" />
        </linearGradient>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        <rect
          fill={`url(#${gradDotId})`}
          x="1606.8"
          y="396.9"
          width="39.1"
          height="43.1"
        />
      </g>
      <path
        fill={`url(#${gradMarkId})`}
        d="M552.1,523.7c0-171.5-47.9-219.4-219.4-219.4s-219.4,47.9-219.4,219.4,47.9,219.4,219.4,219.4,219.4-47.9,219.4-219.4ZM265.6,629.8c-32.9,0-42.1-9.2-42.1-42.1h0v-50.5c7.1,7.1,18.2,8.5,42.1,8.5h0c32.9,0,42.1,9.2,42.1,42.1s-9.2,42.1-42.1,42.1h0ZM376.9,629.8c-11.8,0-21.1-10-20.2-21.8.9-10.7,1.3-22.7,1.3-32v-.4c0-14.6-.9-26.8-3.1-36.9-4.9-22.5-25.3-38.3-48.4-38.3h-1.9c0,.1,0,.1,0,.1-25.6,0-47.4-.9-62.7-4.9-10.9-2.8-18.4-12.7-18.4-23.9v-54.1h176.2c19.9,0,36,16.1,36,36v176.2h-58.8Z"
      />
      <polygon
        fill={textColor}
        points="1606.8 456.5 1606.8 456.5 1606.8 456.5 1606.8 456.5 1606.8 627.5 1606.8 627.5 1645.8 627.5 1645.8 627.5 1645.8 456.5 1645.8 456.5 1606.8 456.5"
      />
      <polygon
        fill={textColor}
        points="848.4 582.8 707.7 402.5 656.1 402.5 656.1 627.5 694.5 627.5 694.5 445.1 836.4 627.5 886.8 627.5 886.8 402.5 848.4 402.5 848.4 582.8"
      />
      <path
        fill={textColor}
        d="M1089,457.7l-4.3,41.7c-.8-1.3-1.6-2.5-2.4-3.8-8.9-13.3-19.8-23.6-32.7-31-12.9-7.4-27.3-11.1-43-11.1s-31.3,3.8-44.1,11.2c-12.8,7.5-22.8,17.9-30,31.2-7.2,13.3-10.8,28.9-10.8,46.6s3.6,33.1,10.8,46.5c7.2,13.4,17.2,23.9,30,31.4,12.8,7.5,27.5,11.2,44.1,11.2s30.1-3.7,43-11.1c12.9-7.4,23.7-17.8,32.6-31.2.9-1.3,1.7-2.6,2.5-4l4.4,42.1h40.2l-9-84.9,9-84.9h-40.2ZM1070.3,572.8c-7.1,8.7-15.3,15.5-24.5,20.4-9.2,4.9-19.2,7.3-30,7.3s-20-2.4-28.2-7.3c-8.2-4.9-14.7-11.7-19.3-20.4-4.7-8.7-7.1-18.8-7.1-30.2s2.3-21.4,7.1-30.1c4.7-8.7,11.1-15.5,19.3-20.4,8.2-4.9,17.6-7.3,28.2-7.3s20.8,2.5,30,7.3c9.2,4.9,17.3,11.7,24.5,20.4,7.1,8.7,12.8,18.8,16.9,30.1-4.2,11.4-9.9,21.5-16.9,30.2Z"
      />
      <path
        fill={textColor}
        d="M1316.1,463.1c-11.2-6.4-24.8-9.6-40.8-9.6s-27.4,3.4-39,10.1c-11.6,6.7-21.1,16.3-28.5,28.6-1.2,2-2.3,4.1-3.4,6.3l-6.8-40.8h-39l10.2,55.5v114.3h39v-82.8c0-11.8,2.2-22.1,6.8-30.9,4.5-8.8,10.9-15.6,19.2-20.6,8.3-4.9,17.9-7.3,28.9-7.3,16,0,28.1,4.6,36.5,13.7,8.3,9.1,12.4,22.6,12.4,40.3v87.6h39v-93.9c0-16.8-3-31.1-8.8-43-5.9-11.9-14.5-21-25.7-27.5Z"
      />
      <path
        fill={textColor}
        d="M1447.8,491.2c9-4.7,19.5-7.1,31.5-7.1s27.8,3.6,38.4,10.8c10.6,7.2,17.3,17.2,20.1,30h39.3c-2-14.2-7.5-26.6-16.5-37.4-9-10.7-20.5-19-34.5-25-14-6-29.6-9-46.8-9s-36.9,3.8-51.8,11.2c-14.9,7.5-26.6,18-34.9,31.3-8.4,13.4-12.6,28.9-12.6,46.5s4.2,33.1,12.6,46.5c8.4,13.4,20,23.9,34.9,31.4,14.9,7.5,32.1,11.2,51.8,11.2s32.8-3,46.8-9c14-6,25.5-14.3,34.5-25,9-10.7,14.5-23,16.5-37.1h-39.3c-2.6,12.2-9.2,22-19.8,29.4-10.6,7.4-23.5,11.1-38.7,11.1s-22.5-2.3-31.5-7c-9-4.7-16-11.4-20.8-20.2-4.9-8.8-7.3-19.2-7.3-31.2s2.4-22.6,7.3-31.3c4.9-8.7,11.8-15.4,20.8-20.1Z"
      />
      <path
        fill={textColor}
        d="M1787.4,601.1c-14.4,0-26.9-2.4-37.4-7.3-10.5-4.9-18.6-11.9-24.3-21.2-3-4.9-5.3-10.3-6.7-16.2h149c0-20.8-3.8-38.9-11.4-54.3-7.6-15.4-18.4-27.3-32.2-35.8-13.9-8.5-30.4-12.8-49.4-12.8s-35.8,3.8-50.6,11.2c-14.7,7.5-26.2,17.9-34.5,31.2-8.3,13.3-12.4,28.8-12.4,46.4s4.4,33.4,13.2,46.8c8.8,13.4,20.9,23.9,36.3,31.4,15.4,7.5,33,11.2,52.8,11.2s30.5-2.3,45.4-6.9c14.9-4.6,27.5-10.9,37.9-18.9v-28.2c-10.4,7.4-22.4,13.2-36,17.2-13.6,4.1-26.9,6.1-39.9,6.1ZM1744.4,491c8.5-4.6,18.4-6.9,29.9-6.9s20.1,2.2,28.1,6.5c7.9,4.3,14.2,10.5,18.9,18.5,3.1,5.2,5.2,11.1,6.6,17.7h-109.3c1.2-6,3.1-11.4,6-16.4,4.8-8.3,11.4-14.7,19.9-19.3Z"
      />
    </Box>
  );
};

// Surbook indicator pictos (cockpit banner), redrawn from the legacy PNGs
// (surbook_upgrade / surbook_downgrade / surbook_delogement / neutral_surbook):
// two bins, and an arrow moving between or out of them. Drawn in currentColor
// so the host chooses the colour.
const surbookStroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;

const SurbookBins = () => (
  <>
    <path d="M1.5 16.5v3h9.5v-3" />
    <path d="M13 10.5v3h9.5v-3" />
  </>
);

export const SurbookNeutralIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...surbookStroke}
  >
    <SurbookBins />
  </svg>
);

export const SurbookUpgradeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...surbookStroke}
  >
    <SurbookBins />
    <path d="M6 16.5C6 10.5 9.5 6 15 6" />
    <path d="M14 3.5l3.5 2.5L14 8.5z" />
  </svg>
);

export const SurbookDowngradeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...surbookStroke}
  >
    <SurbookBins />
    <path d="M17.5 5.5C12 5.5 6.5 8 6.5 13.5" />
    <path d="M4 12.5l2.5 3.5L9 12.5z" />
  </svg>
);

export const SurbookRelocationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...surbookStroke}
  >
    <path d="M1.5 19v3h8.5v-3" />
    <path d="M11 14.5v3h8.5v-3" />
    <path d="M14.5 14.5c0-5 2.5-8 7-8" />
    <path d="M20.5 4l3 2.5-3 2.5z" />
  </svg>
);
